import { ReactElement } from 'react';
import { ITableLogsData } from '../logs-list.models';

export const IsSupport = (data: ITableLogsData): ReactElement => (
  <div className="logs-table__support-cell">
    {data.is_support ? 'Да' : '-'}
  </div>
);
